<template>
	<div class="template-selection">
		<ul class="template-selection__grid center cards mb no-list-style">
			<li v-for="(template, i) in templates" :key="i" class="template-selection__checkbox no-underline relative mb-0">
				<c-deprecated-checkbox
					v-model="template.selected"
					:label-is-text="false"
				>
					<c-template-card
						v-if="template"
						:link-on="false"
						:template="template"
						:index="i"
						class="p-2"
					/>
				</c-deprecated-checkbox>
			</li>
		</ul>
	</div>
</template>

<script lang="ts">
	import Vue from 'vue';
	import CTemplateCard from '@cognitoforms/shared-components/src/components/content/TemplateCard.vue';
	import CDeprecatedCheckbox from '@cognitoforms/shared-components/src/components/form-controls/DeprecatedCheckbox.vue';

	export default Vue.extend({
		name: 'TemplateSelection',
		components: {
			CTemplateCard,
			CDeprecatedCheckbox
		},
		props: {
			templates: { // Templates suited for the industry
				type: Array,
				default: null
			}
		}
	});
</script>

<style lang="scss">
.template-selection {

	&__grid {
		display: grid;
		gap: min($gutter, 4vw);
		grid-template-columns: repeat(1, 1fr);

		@include b-up($b4) {
			grid-template-columns: repeat(2, 1fr);
		}

		@include b-up($b7) {
			grid-template-columns: repeat(3, 1fr);
		}
	}

	&__checkbox {

		&:hover {
			background: $bg__hovered;
		}

		.el-checkbox {

			&.is-checked {
				z-index: $z1;
				background-color: $alexander;
				outline: 2px solid $abraham;

				.el-checkbox__inner {
					outline: 1px solid white;
					opacity: 1;
				}
			}

			.checkable {
				display: flex;
			}

			&__inner {
				position: absolute;
				right: 6px;
				top: 6px;
				z-index: $z1;
				outline: 1px solid $matins;
				opacity: .8;
				font-size: $size__4;
			}
		}
	}

	.checkable,
	.el-checkbox,
	.template-selection__checkbox,
	.template-card__container,
	.el-checkbox__label {
		height: 100%;
	}
}
</style>
